const images = [
  { src: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=600&q=80", label: "Living Room" },
  { src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80", label: "Kitchen" },
  { src: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=600&q=80", label: "Bedroom" },
  { src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80", label: "Dining" },
  { src: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=600&q=80", label: "Wardrobe" },
  { src: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=600&q=80", label: "Bathroom" },
  { src: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=600&q=80", label: "Ceiling Work" },
  { src: "https://images.unsplash.com/photo-1600573472591-ee6b68d14c68?w=600&q=80", label: "Flooring" },
]

export function Gallery() {
  return (
    <section id="gallery" className="border-t border-gray-200 py-20">
      <div className="mx-auto max-w-[1400px] px-8">
        <div className="reveal text-center">
          <p className="text-[11px] font-light tracking-[0.3em] text-gray-400 uppercase">
            Portfolio
          </p>
          <h2 className="font-heading mt-3 text-[40px] leading-[1.15] text-navy sm:text-[48px]">
            OUR GALLERY
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-[15px] font-light leading-relaxed text-gray-400">
            Browse our portfolio showcasing diverse, stunning interior transformations
            and improvements.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
          {images.map((img, i) => (
            <div
              key={i}
              className="reveal group relative overflow-hidden bg-gray-100"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <img
                src={img.src}
                alt={img.label}
                className="h-[240px] w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 flex items-end bg-navy/0 p-4 transition-all duration-500 group-hover:bg-navy/50">
                <span className="translate-y-4 text-[13px] font-light tracking-[0.15em] text-white uppercase opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  {img.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
